import { cardRepository } from '@webapp/modules/spending-cards'
import { ActivatePhysicalCardUseCase } from './ActivatePhysicalCardUseCase'

export const activatePhysicalCardUseCase = new ActivatePhysicalCardUseCase({
  cardRepository,
}).execute
